import { CheckCircleOutlined, FileTextOutlined, WarningTwoTone } from '@ant-design/icons'
import { Alert } from 'antd'
import React from 'react'
import { RouterOutput } from '../../../utils/trpc'

type Props = {
  box: RouterOutput['boxes']['getBoxByIdWithAssemblies']
}

export const DeliveryNoteStatus: React.FC<Props> = ({ box }) => {
  const { deliveryNotePicking, deliveryNote } = box

  if (!deliveryNotePicking || box.pickingState === 'UNMOUNT') {
    return null
  }

  const title = `Albarán Nº ${deliveryNotePicking.deliveryNoteId} · versión ${deliveryNotePicking.version}`
  // The intake changed the products after printing: the paper in hand no longer matches
  const isOutdated = !!deliveryNote && deliveryNote.version > deliveryNote.printedVersion

  if (isOutdated) {
    return (
      <Alert
        className='mb-4'
        type='error'
        showIcon
        icon={<WarningTwoTone twoToneColor='red' />}
        message={<span className='text-lg'>{title}: el envío ha cambiado</span>}
        description='Reimprime el albarán desde Cajas y escanéalo para completar la caja.'
      />
    )
  }

  return deliveryNotePicking.picked
    ? (
      <Alert
        className='mb-4'
        type='success'
        showIcon
        icon={<CheckCircleOutlined />}
        message={<span className='text-lg'>{title}: escaneado</span>}
      />
    )
    : (
      <Alert
        className='mb-4'
        type='warning'
        showIcon
        icon={<FileTextOutlined />}
        message={<span className='text-lg'>{title}: Mete el albarán en esta caja y escanéalo para completarla.</span>}
      />
    )
}
